import React from 'react';
import cx from 'classnames';

import './Hamburger.scss';

export const Hamburger = ({
  isOpen = false,
  onClick
}) => {
  return <span className={cx('sb-header-hamburger', {
    'sb-header-hamburger--open': isOpen
  })} data-test-id="layout.hamburger" onClick={onClick}>
    <div className="sb-header-hamburger__container">
      <span className="sb-header-hamburger__bar"></span>
      <span className="sb-header-hamburger__bar"></span>
      <span className="sb-header-hamburger__bar"></span>
      <span className="sb-header-hamburger__bar"></span>
    </div>
  </span>
}
